export default __webpack_public_path__ + "static/media/invio_telematico.eb12215f.png";